import { useState } from "react";
import { ApiError, api, type CasoDetalle as Caso } from "@/lib/api";
import Modal from "@/ui/Modal";
import { useToast } from "@/ui/Toast";
import SolucionPicker, { type SolucionSeleccion } from "./SolucionPicker";

export default function CerrarCasoModal({
  caso,
  open,
  onOpenChange,
  onClosed,
}: {
  caso: Caso;
  open: boolean;
  onOpenChange: (v: boolean) => void;
  onClosed: (c: Caso) => void;
}) {
  const toast = useToast();
  const [nota, setNota] = useState("");
  const [sel, setSel] = useState<SolucionSeleccion>({
    tipoSolucionId: null,
    solucionesImei: null,
  });
  const [saving, setSaving] = useState(false);

  // Espeja domain/cierre.falta_solucion_para_cierre.
  const completo =
    caso.imeis.length === 0
      ? sel.tipoSolucionId != null
      : sel.solucionesImei
        ? caso.imeis.every((im) => sel.solucionesImei?.[im.id] != null)
        : sel.tipoSolucionId != null;

  async function confirmar() {
    setSaving(true);
    try {
      const updated = await api.post<Caso>(`/api/casos/${caso.id}/cerrar`, {
        nota_cierre: nota.trim() || null,
        tipo_solucion_id: sel.tipoSolucionId,
        soluciones_imei: sel.solucionesImei,
      });
      toast.success("Caso cerrado", caso.folio);
      onOpenChange(false);
      onClosed(updated);
    } catch (err) {
      toast.error("No se pudo cerrar", err instanceof ApiError ? err.detail : "Error");
    } finally {
      setSaving(false);
    }
  }

  return (
    <Modal open={open} onOpenChange={onOpenChange} title={`Cerrar ${caso.folio}`}>
      <div className="space-y-3">
        <p className="text-sm text-zinc-400">
          Para cerrar, indica cómo se resolvió. Esto alimenta las estadísticas. Al
          cerrarlo, sus recordatorios pendientes se cancelan solos.
        </p>
        <SolucionPicker imeis={caso.imeis} value={sel} onChange={setSel} />
        <div className="space-y-1">
          <label className="text-xs uppercase tracking-wide text-zinc-400">
            Nota de cierre (opcional)
          </label>
          <textarea
            className="input min-h-[64px]"
            value={nota}
            onChange={(e) => setNota(e.target.value)}
          />
        </div>
        <div className="flex justify-end gap-2">
          <button className="btn-ghost" onClick={() => onOpenChange(false)}>
            Cancelar
          </button>
          <button
            className="btn bg-emerald-600 hover:bg-emerald-500 text-white disabled:opacity-50"
            disabled={!completo || saving}
            onClick={() => void confirmar()}
          >
            {saving ? "Cerrando..." : "Cerrar caso"}
          </button>
        </div>
      </div>
    </Modal>
  );
}
